import { Injectable } from '@angular/core';
import { Item } from '@app/core/components/listbox/listbox.component';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({ providedIn: 'root' })
export class P2TableService {
    constructor(private datatask: DataTaskService) {}

    public async listTables(): Promise<P2TableItem[]> {
        return this.datatask.Post(24);
    }

    public async getTable(params: GetP2TableParams): Promise<P2TableGet> {
        return (await this.datatask.Post(25, params))[0];
    }

    public async saveTable(table: P2TableGet): Promise<P2TableSaveResponse> {
        return (await this.datatask.Post(26, table))[0];
    }
}

export interface P2TableItem extends Item {
    item_state?: string;
}

export interface GetP2TableParams {
    p2_table_keyno: string;
}

export interface P2TableGet {
    p2_table_keyno: string;
    table_name: string;
    word_id: string;
}

export interface P2TableSaveResponse {
    iserror: '0' | '1';
    message: string;
}
